import React from "react";
import * as Animate from "react-reveal";
import ExperimentIcon from "../../../assets/images/svg/experiment.svg";
import LearningIcon from "../../../assets/images/svg/intensive-learning-white.svg";
import PeopleIcon from "../../../assets/images/svg/people.svg";

import MapImage from "../../../assets/images/png/individual/map.webp";

const ListItem = ({ listData }) => {
  return (
    <div className="flex flex-row items-start gap-2 text-white">
      <span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.7959 7.54597L9.7959 19.546C9.69138 19.6509 9.56719 19.7341 9.43044 19.7909C9.2937 19.8476 9.14709 19.8769 8.99902 19.8769C8.85096 19.8769 8.70435 19.8476 8.5676 19.7909C8.43085 19.7341 8.30666 19.6509 8.20215 19.546L2.95215 14.296C2.8475 14.1913 2.76449 14.0671 2.70785 13.9304C2.65122 13.7936 2.62207 13.6471 2.62207 13.4991C2.62207 13.3511 2.65122 13.2046 2.70785 13.0678C2.76449 12.9311 2.8475 12.8069 2.95215 12.7022C3.05679 12.5976 3.18103 12.5146 3.31776 12.4579C3.45448 12.4013 3.60103 12.3721 3.74902 12.3721C3.89702 12.3721 4.04356 12.4013 4.18029 12.4579C4.31702 12.5146 4.44125 12.5976 4.5459 12.7022L8.99996 17.1563L20.204 5.9541C20.4154 5.74276 20.702 5.62402 21.0009 5.62402C21.2998 5.62402 21.5864 5.74276 21.7978 5.9541C22.0091 6.16544 22.1278 6.45209 22.1278 6.75098C22.1278 7.04986 22.0091 7.33651 21.7978 7.54785L21.7959 7.54597Z"
            fill="white"
          />
        </svg>
      </span>
      <span>
        <strong>{listData?.title}:</strong> {listData?.content}
      </span>
    </div>
  );
};

const Card = ({ datum }) => {
  return (
    <div className="pb-4">
      <div className="flex flex-row items-end gap-3">
        <img src={datum?.icon} alt="Icon" />
        <p className="font-semibold font-mono text-2xl lg:text-3xl xl:text-4xl text-white">
          {datum?.title}
        </p>
      </div>

      <div className="mt-10 text-white text-sm-15 lg:text-base space-y-5 xl:w-11/12">
        {datum?.listData?.map((item) => (
          <ListItem key={item?.id} listData={item} />
        ))}
      </div>
    </div>
  );
};

const InvestingSection = () => {
  const data = [
    {
      id: 1,
      icon: LearningIcon,
      title: "Utiva Learn",
      listData: [
        {
          title: "Personalized Learning",
          content:
            "AI-driven paths, mentor-led sessions, projects & portfolio.",
        },
        {
          title: "Recognized Credentials",
          content: "Micro-certifications (UK/US accredited).",
        },
        {
          title: "Career Growth",
          content: "Placement coaching & team plans.",
        },
      ],
    },
    {
      id: 2,
      icon: PeopleIcon,
      title: "Utiva Hire",
      listData: [
        {
          title: "Smart Matching",
          content: "AI + skills/English assessments, shortlist in 24–72h.",
        },
        {
          title: "Flexible Hiring",
          content:
            "Contractor, staff augmentation, trial-to-hire, or full-time.",
        },
        {
          title: "Ongoing Support",
          content: "Dedicated delivery manager.",
        },
      ],
    },
    {
      id: 3,
      icon: ExperimentIcon,
      title: "Utiva Pay",
      listData: [
        {
          title: "Payments & Compliance",
          content: "Multi-currency, local contracts, tax, benefits.",
        },
        {
          title: "Flexible Hiring",
          content: "Contractor, trial-to-hire, staff aug, full-time.",
        },
        {
          title: "Support",
          content: "Delivery manager + simple integrations.",
        },
      ],
    },
  ];
  return (
    <section className="pt-10 lg:pt-14 pb-6 lg:pb-10 individual-investing-section">
      <div className="container mx-auto px-4">
        <div className="flex flex-row justify-between">
          <div className="w-full lg:w-8/12 xl:w-6/12">
            <Animate.Fade bottom>
              <h2 className="text-white text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-semibold">
                Why <span className="text-secondary">Utiva?</span>{" "}
              </h2>

              <p className="mt-6 text-sm-15 lg:text-base xl:text-lg lg:leading-7 w-full text-white">
                From learning and talent matching to payments and compliance,
                Utiva makes global talent accessible, simple and seamless.
              </p>
            </Animate.Fade>
          </div>
          <div className="hidden lg:block w-3/12 mx-auto -mt-8">
            <img src={MapImage} alt="" />
          </div>
        </div>

        <div className="relative mt-8 md:mt-0 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-6 lg:gap-16 xl:gap-20">
          {data?.map((datum) => (
            <Card key={datum?.id} datum={datum} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default InvestingSection;
